import { parse, add, parseISO, eachDayOfInterval } from 'date-fns'

export const getWeekDates = (year, week) => {
  const startDate = parse(`${week}`, 'I', new Date(year, 1, 0))
  const endDate = add(startDate, { days: 6 })

  return [startDate, endDate]
}

export const clone = (source) => JSON.parse(JSON.stringify(source))

export const getWeek = (startDate, endDate) => {
  const start = parseISO(startDate)
  const end = parseISO(endDate)

  const days = eachDayOfInterval({ start, end })

  return {
    start,
    end,
    days,
  }
}
